import { Box, Center, type GridItemProps, IconButton } from "@chakra-ui/react";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { t } from "@lingui/macro";
import { DragHandle } from "@src/components/ui-kit";
import { forwardRef, type Ref } from "react";

export interface TaskRowItemProps extends GridItemProps {
  isReorderable?: boolean;
  listeners?: SyntheticListenerMap;
}
export const TaskRowItem = forwardRef(function TaskRowItem(
  { isReorderable, listeners, children, ...props }: TaskRowItemProps,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <Box
      overflow="hidden"
      px="3"
      bg="inherit"
      borderRight="1px"
      borderRightColor="gray.200"
      {...props}
      ref={ref}
    >
      {children}
      {isReorderable && (
        <Center pos="absolute" top="0" right="4" bottom="0" cursor="grab">
          <IconButton
            {...listeners}
            minW="0"
            _groupHover={{ visibility: "visible" }}
            visibility="hidden"
            aria-label={t`Drag to reorder`}
            colorScheme="gray"
            icon={<DragHandle />}
            paddingInline="0"
            size="sm"
            variant="subtle"
          />
        </Center>
      )}
    </Box>
  );
});
